import { VCS_INTEGRATIONS_COLUMN_ID } from "../constants";
import VCSIntegrationsTableDescriptionCell from "./DescriptionCell";
import VCSIntegrationsTableDropdownCell from "./DropdownCell";
import VCSIntegrationsTableIssuesCell from "./IssuesCell";
import VCSIntegrationsTableLabelsCell from "./LabelsCell";
import VCSIntegrationsTableNameCell from "./NameCell";
import VCSIntegrationsTableSpaceCell from "./SpaceCell";

const VCS_INTEGRATIONS_TABLE_CELLS = {
  [VCS_INTEGRATIONS_COLUMN_ID.NAME]: VCSIntegrationsTableNameCell,
  [VCS_INTEGRATIONS_COLUMN_ID.ISSUES]: VCSIntegrationsTableIssuesCell,
  [VCS_INTEGRATIONS_COLUMN_ID.DESCRIPTION]: VCSIntegrationsTableDescriptionCell,
  [VCS_INTEGRATIONS_COLUMN_ID.LABELS]: VCSIntegrationsTableLabelsCell,
  [VCS_INTEGRATIONS_COLUMN_ID.SPACE]: VCSIntegrationsTableSpaceCell,
  [VCS_INTEGRATIONS_COLUMN_ID.DROPDOWN]: VCSIntegrationsTableDropdownCell,
};

export default VCS_INTEGRATIONS_TABLE_CELLS;
